<div class="modal-container main-font">
  <div class="modal-content-container">
    <div class="modal-header-container">
      <div class="title-container">
        <p class="modal-title mb-0">
          {{ request ? 'Modifica' : 'Nuova' }} Review
        </p>
      </div>
    </div>

    <div class="modal-content">
      <div class="modal-content">
        <div class="user-container">
          <img
            [src]="utilityService.getSanitizeUrl(user.path)"
            [alt]="user.first_name"
            class="user-image" />
          <div class="user-info-container">
            <p class="user-name mb-0">
              {{ user.first_name }} {{ user.last_name }}
            </p>
            <p class="user-role mb-0">{{ user.role }}</p>
          </div>
        </div>
        <form class="form-container" [formGroup]="reviewForm">
          <div class="date-content">
            <div class="date-container">
              <img
                src="assets/images/icon_calendar/calendar.svg"
                alt="calendar"
                class="icon-calendar-date" />
              <div class="day-container">
                <p class="mb-0 text-date">{{ getFormattedDate(date) }}</p>
              </div>
            </div>
            <div class="time-container">
              <nz-time-picker
                [nzDisabledHours]="disabledHoursStart"
                [nzMinuteStep]="15"
                [nzHideDisabledOptions]="true"
                nzFormat="HH:mm"
                [nzNowText]="' '"
                [nzPlaceHolder]="'Ora inizio'"
                formControlName="startTime"></nz-time-picker>
              <nz-time-picker
                nzFormat="HH:mm"
                [nzHideDisabledOptions]="true"
                [nzDisabledHours]="disabledHoursEnd"
                [nzDisabledMinutes]="disabledMinutesEnd"
                [nzDisabled]="!reviewForm.value.startTime"
                [nzMinuteStep]="15"
                [nzNowText]="' '"
                [nzPlaceHolder]="'Ora fine'"
                formControlName="endTime"></nz-time-picker>
            </div>
          </div>
          <div class="location-container">
            <img
              src="assets/images/icon_calendar/map-pointer.svg"
              alt="pointer"
              class="icon-pointer" />
            <nz-select
              class="w-100"
              nzPlaceHolder="Seleziona sala"
              formControlName="room">
              <nz-option
                *ngFor="let room of rooms"
                [nzValue]="room.id"
                [nzLabel]="room.alias"></nz-option>
            </nz-select>
          </div>
          <div class="note-container">
            <img
              src="assets/images/icon_calendar/note.svg"
              alt="note"
              class="icon-note" />
            <textarea
              class="w-100"
              nz-input
              placeholder="Note"
              [nzAutosize]="{ minRows: 3, maxRows: 3 }"
              formControlName="note"></textarea>
          </div>
        </form>
      </div>
      <div class="modal-footer-container">
        <button class="primary-btn-outline-new w-100" (click)="closeModal()">
          Annulla
        </button>
        <button
          class="primary-btn-new w-100"
          [disabled]="reviewForm.invalid"
          (click)="request ? updateReview() : storeReview()">
          {{ request ? 'Modifica' : 'Salva' }}
        </button>
      </div>
    </div>
  </div>
</div>
